/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Grid, Skeleton, Typography, Typography2, breakpoints } from '@coursera/cds-core';

import { HERO_BANNER_CONTENT_CONTAINER_MAX_WIDTH } from 'bundles/shared-articles/constants';

const styles = {
  bannerContainer: css`
    min-height: 285px;
    max-width: ${HERO_BANNER_CONTENT_CONTAINER_MAX_WIDTH}px;
    margin: 0 auto;
    ${breakpoints.down('md')} {
      max-width: 90%;
    }
    ${breakpoints.down('xs')} {
      min-height: 180px;
    }
  `,
  bannerTitleContainer: css`
    padding: var(--cds-spacing-300) 0;
  `,
  titleWithoutBreadcrumb: css`
    margin-top: var(--cds-spacing-600);
    ${breakpoints.down('xs')} {
      margin-top: var(--cds-spacing-400);
    }
  `,
  subtitle: css`
    max-width: 90%;
    margin-top: var(--cds-spacing-400);
    ${breakpoints.down('xs')} {
      max-width: 100%;
    }
  `,
  imageWrapper: css`
    ${breakpoints.down('xs')} {
      display: none;
    }
  `,
};

const ArticleHubHeroBannerPlaceholder = () => (
  <Grid container component="div" css={styles.bannerContainer} justifyContent="space-between">
    <Grid item css={styles.bannerTitleContainer} xs={12} sm={6} md={5}>
      <Typography component="h1" variant="d2" css={styles.titleWithoutBreadcrumb}>
        <Skeleton variant="rect" />
      </Typography>
      <Typography2 component="p" variant="bodyPrimary" css={styles.subtitle}>
        <Skeleton variant="rect" height={50} />
      </Typography2>
    </Grid>
    <Grid item container justifyContent="center" alignContent="center" xs={12} sm={6} md={7} css={styles.imageWrapper}>
      <div>
        <Skeleton variant="circle" width={200} height={200} />
      </div>
    </Grid>
  </Grid>
);

export default ArticleHubHeroBannerPlaceholder;
